/**
 * Lệnh Bot — Remove Limit navigation config.
 */

export const REMOVE_LIMIT_ROUTE_NAME = 'LenhBotRemoveLimit'
export const REMOVE_LIMIT_ITEM_ID    = 'lenh-bot-remove-limit'
export const REMOVE_LIMIT_LABEL      = 'Remove Limit'
export const REMOVE_LIMIT_TITLE      = 'Lệnh Bot · Remove Limit'
